import type { ResponsiveContainerProps } from '@wix/thunderbolt-becky-types'
import type { BuilderProps } from '../Builder/Builder'

export const InternalContainerBuilderType = 'wixSystemElements.InternalContainer'

type ContainerType = 'simple' | 'slot' | 'placeholder' | 'template'

export type InternalContainerProps = {
	layers: Record<ContainerType, Array<string>>
	responsiveContainerProps: ResponsiveContainerProps
} & BuilderProps
